import { useMutation, useQueryClient } from "react-query";
import { mutatePatchFn } from "../../services/networking.service";
import ENDPOINTS from "../../services/endPoints";

export const useResolveErrorLog = () => {
  const queryClient = useQueryClient();
  return useMutation<any, any, { id: string }>(
    ({ id }) => mutatePatchFn(
      ENDPOINTS.ERROR_LOG_RESOLVE.replace(":id", id),
      {}
    ),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([ENDPOINTS.ERROR_LOGS]);
      },
    }
  );
};
